import isEqual from "react-fast-compare";
import { useRef, useMemo, DependencyList } from "react";

/**
 * 自定义 Hook，使用深度比较来决定是否重新计算记忆化的值
 * @template T 函数返回值的类型
 * @template D 依赖数组的类型
 * @param {() => T} fn 要记忆化的函数
 * @param {D} deps 依赖数组，会进行深度比较
 * @returns {T} 记忆化的计算结果
 */
export function useDeepCompareMemo<T, D extends DependencyList>(
  fn: () => T,
  deps: D,
): T {
  // 使用更明确的类型来存储依赖引用，并提供初始值 undefined
  const depsRef = useRef<D | undefined>(undefined);

  // 当依赖项为 undefined 或者与上一次的依赖不相等时，更新引用
  if (!depsRef.current || !isEqual(deps, depsRef.current)) {
    depsRef.current = deps;
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(fn, [depsRef.current]);
}
